module.exports = __webpack_public_path__ + "img/nav-mxqh.83cedb74.png";